import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject
} from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { NavbarComponent } from '@app/containers/navbar/navbar.component';
import { AuthService } from '@auth/services/auth.service';
import { ENVIRONMENT } from '@env/environment';
import { SeoService } from '@shared/services/seo.service';
import { USER_STORE } from '@stores/user.store';
import { ZendeskFloatingButtonComponent } from '@zendesk/components/zendesk-floating-button/zendesk-floating-button.component';
import { ZendeskService } from '@zendesk/services/zendesk.service';

@Component({
  selector: 'app-root',
  template: `
    <app-navbar />
    <router-outlet />
    <app-zendesk-floating-button />
  `,
  standalone: true,
  imports: [NavbarComponent, RouterOutlet, ZendeskFloatingButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  readonly #seoService = inject(SeoService);
  readonly #authService = inject(AuthService);
  readonly #userStore = inject(USER_STORE);
  readonly #zendeskService = inject(ZendeskService);

  constructor() {
    this.#seoService.init();
    this.#zendeskService.initialize();

    effect(() => {
      const user = this.#userStore.data();

      // !IMPORTANT do not merge conditions - we must check user
      if (user && !user.termsAndConditionsAccepted) {
        window.location.href = `${ENVIRONMENT.coreModule.locationUrl}`;
      }
    });
  }

  async signOut(): Promise<void> {
    this.#authService.signOut();
  }
}
